var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.854 0.645917C11.9006 0.692363 11.9375 0.747538 11.9627 0.808284C11.9879 0.869029 12.0009 0.93415 12.0009 0.999917C12.0009 1.06568 11.9879 1.13081 11.9627 1.19155C11.9375 1.2523 11.9006 1.30747 11.854 1.35392L4.85402 8.35392C4.80758 8.40048 4.7524 8.43742 4.69166 8.46263C4.63091 8.48784 4.56579 8.50081 4.50002 8.50081C4.43425 8.50081 4.36913 8.48784 4.30839 8.46263C4.24764 8.43742 4.19247 8.40048 4.14602 8.35392L0.646021 4.85392C0.552134 4.76003 0.49939 4.63269 0.49939 4.49992C0.49939 4.36714 0.552134 4.2398 0.646021 4.14592C0.739908 4.05203 0.867245 3.99929 1.00002 3.99929C1.1328 3.99929 1.26013 4.05203 1.35402 4.14592L4.50002 7.29292L11.146 0.645917C11.1925 0.599354 11.2476 0.562411 11.3084 0.537205C11.3691 0.511998 11.4343 0.499023 11.5 0.499023C11.5658 0.499023 11.6309 0.511998 11.6917 0.537205C11.7524 0.562411 11.8076 0.599354 11.854 0.645917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.fe58b7e636295db3fa8dcda096cfb373.svg";
export { ForwardRef as ReactComponent };